module.exports = __webpack_public_path__ + "static/year1998-7ab33a56e7ec174f396bae63c26002e5.jpg";